import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="py-24 lg:py-32 bg-white" data-id="element-159">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto text-center" data-id="element-161">
          <h2 className="text-4xl lg:text-5xl font-bold text-[var(--color-charcoal)] mb-8 leading-tight" data-id="element-162">
            ¿Sientes que nada de lo que intentas funciona?
          </h2>

          <p className="text-xl lg:text-2xl text-[var(--color-charcoal)] opacity-80 font-light leading-relaxed" data-id="element-163">
            No es tu falta de voluntad. Es que la mayoría de los programas no
            fueron diseñados para esta etapa de tu vida. Tu cuerpo ha cambiado —
            tu enfoque también puede hacerlo.
          </p>
        </motion.div>
      </div>
    </section>;
}